/*
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-16 16:40:01
 * @LastEditTime: 2020-07-16 17:36:39
 */
const Tpl = () => import(/* webpackChunkName: "tpl" */'./views')
const TplHome = () => import(/* webpackChunkName: "tpl-home" */'./views/children/home')

// import layout from './views/components/layout'
export default () => ({
  path: '/tpl',
  component: Tpl,
  redirect: '/tpl/home',
  // meta: { layout },
  children: [
    {
      path: 'home',
      component: TplHome,
    },
  ],
})
